import {Component, Input, OnInit} from '@angular/core';
import {DashboardService} from '@services/dashboard.service';
import {DataBuilderModalService} from '@services/data-builder-modal.service';
import {RequestService} from '@services/request.service';

@Component({
    selector: 'app-autoload-riepilogo',
    templateUrl: './autoload-riepilogo.component.html',
    styleUrls: ['./autoload-riepilogo.component.css']
})
export class AutoloadRiepilogoComponent implements OnInit {
    data: any;
    autoloadTableUrl: string;
    status = 'hidden';

    @Input() brand: string
    constructor(
        private requestService: RequestService,
        public dbm: DataBuilderModalService
    ) {
    }

    _urlRiepilogo: string;

    @Input() set urlRiepilogo(value: string) {
        this._urlRiepilogo = value;

        if (this._urlRiepilogo !== undefined) {
            this.loadRiepilogo();
        }
    }

    ngOnInit() {

    }

    public setUrl(url: string) {
        this.urlRiepilogo = url;
    }

    private loadRiepilogo() {
        this.status = 'loading';
        this.requestService.get(this.brand + this._urlRiepilogo)
            .subscribe((data) => {
                this.data = data.result;
                this.status = 'hidden';
            }, (error) => {
                this.status = 'error';
            });
    }
}
